export default function WhyBook() {
    const benefits = [
        {
            number: "01",
            title: "Exclusive Deals",
            description:
                "Get access to exclusive hotel deals and special discounts.",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-7 w-7"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.847-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.847a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.847.813a4.5 4.5 0 0 0-3.09 3.09Z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M18.259 8.715 18 9.75l-.259-1.035a2.25 2.25 0 0 0-1.65-1.65L15.056 6.75l1.035-.259a2.25 2.25 0 0 0 1.65-1.65L18 3.75l.259 1.091a2.25 2.25 0 0 0 1.65 1.65l1.035.259-1.035.259a2.25 2.25 0 0 0-1.65 1.706Z"
                    />
                </svg>
            ),
        },
        {
            number: "02",
            title: "Wide Selection",
            description:
                "Choose from 1000+ hotels across Dubai's most popular areas.",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-7 w-7"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.75 21h16.5M4.5 21V9.75A1.5 1.5 0 0 1 6 8.25h3A1.5 1.5 0 0 1 10.5 9.75V21m3 0V4.5A1.5 1.5 0 0 1 15 3h3a1.5 1.5 0 0 1 1.5 1.5V21"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M7 12h.01M7 15h.01M7 18h.01M16 7h.01M16 10h.01M16 13h.01M16 16h.01M16 19h.01"
                    />
                </svg>
            ),
        },
        {
            number: "03",
            title: "Trusted Reviews",
            description:
                "Make confident decisions with reviews from real guests.",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-7 w-7"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6.633 10.25c.806 0 1.533-.446 1.902-1.17l.612-1.2c.423-.83 1.266-1.35 2.197-1.35h.905c.828 0 1.5.672 1.5 1.5v.75h2.168c1.38 0 2.5 1.12 2.5 2.5v.75c0 3.728-3.022 6.75-6.75 6.75H8.25a3 3 0 0 1-3-3v-5.53c0-.276.224-.5.5-.5h.883Z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M14.25 8.78V6.75a2.25 2.25 0 0 0-2.25-2.25h-.75"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 10.25v6.75"
                    />
                </svg>
            ),
        },
        {
            number: "04",
            title: "24/7 Support",
            description:
                "Our support team is available whenever you need assistance.",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-7 w-7"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 11.25V9a3.75 3.75 0 0 1 7.5 0v2.25M6 18.75a3 3 0 0 1-3-3v-3a3 3 0 0 1 3-3h.75v6H6ZM18 18.75a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3h-.75v6H18Z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 18.75h1.5a2.25 2.25 0 0 0 2.25-2.25v-.75"
                    />
                </svg>
            ),
        },
        {
            number: "05",
            title: "Flexible Payments",
            description:
                "Enjoy convenient payment options designed around your needs.",
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-7 w-7"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 8.25h19.5M4.5 5.25h15A2.25 2.25 0 0 1 21.75 7.5v9A2.25 2.25 0 0 1 19.5 18.75h-15A2.25 2.25 0 0 1 2.25 16.5v-9A2.25 2.25 0 0 1 4.5 5.25Z"
                    />
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6.75 14.25h3"
                    />
                </svg>
            ),
        },
    ];

    return (
        <section
            className="
                relative
                w-full
                overflow-hidden
                bg-[#F7F5EF]
                py-14
                sm:py-16
                lg:py-20
            "
        >
            {/* =====================================================
                SUBTLE BACKGROUND DETAILS
            ===================================================== */}

            <div
                className="
                    pointer-events-none
                    absolute
                    -left-40
                    top-10
                    h-80
                    w-80
                    rounded-full
                    bg-[#E7DED0]/40
                    blur-3xl
                "
            />

            <div
                className="
                    pointer-events-none
                    absolute
                    -right-40
                    bottom-0
                    h-80
                    w-80
                    rounded-full
                    bg-[#D5A33C]/5
                    blur-3xl
                "
            />

            <div
                className="
                    relative
                    mx-auto
                    max-w-[1440px]
                    px-5
                    sm:px-8
                    lg:px-12
                    xl:px-16
                "
            >
                {/* =====================================================
                    SECTION INTRO
                ===================================================== */}

                <div
                    className="
                        mb-10
                        flex
                        flex-col
                        gap-5

                        lg:mb-12
                        lg:flex-row
                        lg:items-end
                        lg:justify-between
                    "
                >
                    <div className="max-w-[620px]">

                        {/* Eyebrow */}

                        <div
                            className="
                                mb-3
                                flex
                                items-center
                                gap-3
                            "
                        >
                            <span
                                className="
                                    h-[1px]
                                    w-8
                                    bg-[#D5A33C]
                                "
                            />

                            <span
                                className="
                                    text-[10px]
                                    font-semibold
                                    uppercase
                                    tracking-[0.22em]
                                    text-[#0B5552]
                                "
                            >
                                Why Book With Us
                            </span>
                        </div>

                        {/* Heading */}

                        <h2
                            className="
                                font-serif
                                text-[30px]
                                font-medium
                                leading-[1.08]
                                tracking-[-0.02em]
                                text-[#173F3E]

                                sm:text-[36px]

                                lg:text-[42px]
                            "
                        >
                            A better way to book your
                            <span
                                className="
                                    italic
                                    text-[#B78932]
                                "
                            >
                                {" "}Dubai stay.
                            </span>
                        </h2>
                    </div>

                    {/* Description */}

                    <p
                        className="
                            max-w-[440px]
                            text-[12px]
                            leading-6
                            text-[#687572]

                            sm:text-[13px]
                        "
                    >
                        From finding the right hotel to securing the
                        best available rate, we make your Dubai hotel
                        booking experience simple, transparent and
                        stress-free.
                    </p>
                </div>

                {/* =====================================================
                    BENEFIT GRID
                ===================================================== */}

                <div
                    className="
                        overflow-hidden
                        rounded-[18px]
                        border
                        border-[#DED8CC]
                        bg-[#FBFAF6]
                        shadow-[0_10px_35px_rgba(15,45,44,0.06)]
                    "
                >
                    <div
                        className="
                            grid
                            grid-cols-1

                            sm:grid-cols-2

                            lg:grid-cols-5
                        "
                    >
                        {benefits.map((benefit, index) => (
                            <div
                                key={benefit.title}
                                className={`
                                    group
                                    relative
                                    flex
                                    min-h-[215px]
                                    flex-col
                                    px-6
                                    py-7

                                    transition-all
                                    duration-500

                                    hover:bg-[#073F3D]

                                    sm:px-7

                                    lg:min-h-[240px]
                                    lg:px-6
                                    lg:py-8

                                    xl:px-7

                                    ${index !== 0
                                        ? `
                                                border-t
                                                border-[#DED8CC]

                                                sm:border-t-0
                                                ${index === 1 ||
                                            index === 3
                                            ? "sm:border-l"
                                            : ""
                                        }

                                                lg:border-l
                                            `
                                        : ""
                                    }
                                `}
                            >
                                {/* =================================================
                                    NUMBER
                                ================================================== */}

                                <div
                                    className="
                                        flex
                                        items-center
                                        justify-between
                                    "
                                >
                                    <span
                                        className="
                                            font-serif
                                            text-[12px]
                                            italic
                                            text-[#B78932]

                                            transition-colors
                                            duration-500

                                            group-hover:text-[#E5C56D]
                                        "
                                    >
                                        {benefit.number}
                                    </span>

                                    <span
                                        className="
                                            h-[1px]
                                            w-8
                                            bg-[#D5A33C]/50

                                            transition-all
                                            duration-500

                                            group-hover:w-12
                                            group-hover:bg-[#E5C56D]
                                        "
                                    />
                                </div>

                                {/* =================================================
                                    ICON
                                ================================================== */}

                                <div
                                    className="
                                        mt-7
                                        flex
                                        h-12
                                        w-12
                                        items-center
                                        justify-center
                                        rounded-full
                                        border
                                        border-[#D5A33C]/40
                                        bg-[#F3EBDD]
                                        text-[#0B5552]

                                        transition-all
                                        duration-500

                                        group-hover:-translate-y-1
                                        group-hover:border-[#E5C56D]
                                        group-hover:bg-[#E5C56D]
                                        group-hover:text-[#173F3E]
                                    "
                                >
                                    {benefit.icon}
                                </div>

                                {/* =================================================
                                    TITLE
                                ================================================== */}

                                <h3
                                    className="
                                        mt-5
                                        font-serif
                                        text-[18px]
                                        font-medium
                                        leading-tight
                                        text-[#173F3E]

                                        transition-colors
                                        duration-500

                                        group-hover:text-white
                                    "
                                >
                                    {benefit.title}
                                </h3>

                                {/* =================================================
                                    DESCRIPTION
                                ================================================== */}

                                <p
                                    className="
                                        mt-2
                                        max-w-[210px]
                                        text-[11px]
                                        leading-5
                                        text-[#77827F]

                                        transition-colors
                                        duration-500

                                        group-hover:text-white/70
                                    "
                                >
                                    {benefit.description}
                                </p>

                                {/* =================================================
                                    GOLD BOTTOM ACCENT
                                ================================================== */}

                                <div
                                    className="
                                        absolute
                                        bottom-0
                                        left-0
                                        h-[2px]
                                        w-0
                                        bg-[#D5A33C]

                                        transition-all
                                        duration-500

                                        group-hover:w-full
                                    "
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* =====================================================
                    BOTTOM TRUST LINE
                ===================================================== */}

                <div
                    className="
                        mt-7
                        flex
                        flex-col
                        items-center
                        justify-center
                        gap-2
                        text-center

                        sm:flex-row
                        sm:gap-3
                    "
                >
                    <span
                        className="
                            h-1.5
                            w-1.5
                            rounded-full
                            bg-[#D5A33C]
                        "
                    />

                    <span
                        className="
                            text-[10px]
                            font-medium
                            uppercase
                            tracking-[0.16em]
                            text-[#687572]
                        "
                    >
                        Your Dubai stay starts with the right choice
                    </span>

                    <span
                        className="
                            h-1.5
                            w-1.5
                            rounded-full
                            bg-[#D5A33C]
                        "
                    />
                </div>
            </div>
        </section>
    );
}